import { useListContext, useTranslate } from 'react-admin';
import { BarChartWithTrend } from '@/components/analytics/common/BarChartWithTrend.jsx';
import { prepareTrendChartData } from '@/helpers/analytics/charts.js';
import { AnalyticsChartTitle } from '@/components/analytics/common/AnalyticsChartTitle.jsx';
import { AnalyticsChartSubtitle } from '@/components/analytics/common/AnalyticsChartSubtitle.jsx';
import { ChartAnalyticsCard } from '@/components/analytics/common/ChartAnalyticsCard.jsx';

export const TransactionCountAnalytics = () => {
    const { data } = useListContext();
    const translate = useTranslate();

    if (!data || data.length === 0) return null;
    const analytic = data[0].data;
    const previous = data[1].data;
    const series = data.find(s => s.id === 'series').data;
    const chartData = prepareTrendChartData(series, 'transactionsCount');
    return (
        <ChartAnalyticsCard
            data={chartData}
            dataKey='transactionsCount'
            stats={
                <>
                    <AnalyticsChartTitle
                        title={translate('common.transactionsNumber')}
                        value={analytic.transactionsCount}
                        growth={((analytic.transactionsCount - previous.transactionsCount) / previous.transactionsCount) * 100}
                    />
                    <AnalyticsChartSubtitle label={translate('analytics.transaction.value')} value={analytic.transactionsCashDepositSum} unit='PLN' />
                </>
            }
            chart={<BarChartWithTrend data={chartData} dataKey='transactionsCount' label={translate('common.transactionsNumber')} />}
        />
    );
};
